import { NextUrqlPageContext } from 'next-urql'
import { isServerSide } from 'lib/env'

export const ssrRedirect = (ctx: NextUrqlPageContext, url: string) => {
    if (isServerSide) {
        ctx.res?.writeHead(302, { Location: url })
        ctx.res?.end()
    }
}
